import axios from 'axios'
import { TOKEN } from '@/constant/common'
import eventBus from './eventBus'
import logger from './logger'
import { getHmToken } from './hmToken'

// create an axios instance
const service = axios.create({
  baseURL: process.env.NODE_ENV !== 'production' ? '/api' : '',
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 90000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    const url = config.url
    if (!url.startsWith('http')) {
      config.headers.Authorization = TOKEN
    }
    config.headers.Token = getHmToken() || ''
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    const resp = response.data
    const requestUrl = response.config.url
    if ((requestUrl.includes('/django_rest/') || requestUrl.includes('/wecom/api/')) && resp.hasOwnProperty('code')) {
      if (resp.code !== 200) {
        eventBus.$emit('responseErrorCode', resp.code, resp)
        logger.send({
          type: 'axios.interceptors.response.onFulfilled',
          from: 'args',
          data: {
            response
          }
        })
        return Promise.reject(resp)
      } else {
        return resp.data
      }
    }

    return resp
  },
  error => {
    logger.send({
      type: 'axios.interceptors.response.onRejected',
      from: 'args',
      data: {
        error
      }
    })
    if (error.response.data instanceof ArrayBuffer) {
      const decoder = new TextDecoder()
      const dataStr = decoder.decode(error.response.data)
      return Promise.reject(JSON.parse(dataStr))
    }
    eventBus.$emit('responseHttpError', error.response.status, error)
    return Promise.reject(error)
  }
)

const outSiteRequest = axios.create({
  timeout: 90000 // request timeout
})
outSiteRequest.interceptors.response.use(response => response.data)

const serviceV2 = axios.create({
  baseURL: process.env.NODE_ENV !== 'production' ? '/service/v2' : '/v2',
  timeout: 90000 // request timeout
})

serviceV2.interceptors.request.use(
  config => {
  // do something before request is sent
    const url = config.url
    if (!url.startsWith('http')) {
      config.headers.Authorization = TOKEN
    }
    config.headers.Token = getHmToken() || ''
    return config
  }, error => {
    return Promise.reject(error)
  }
)

serviceV2.interceptors.response.use(response => {
  const resp = response.data
  if (resp.hasOwnProperty('code')) {
    if (resp.code !== 200) {
      eventBus.$emit('responseErrorCode', resp.code, resp)
      logger.send({
        type: 'axios.interceptors.response.onFulfilled',
        from: 'args',
        data: {
          response
        }
      })
      return Promise.reject(resp)
    } else {
      return resp.data
    }
  }

  return resp
}, error => {
  logger.send({
    type: 'axios.interceptors.response.onRejected',
    from: 'args',
    data: {
      error
    }
  })
  if (error.response.data instanceof ArrayBuffer) {
    const decoder = new TextDecoder()
    const dataStr = decoder.decode(error.response.data)
    return Promise.reject(JSON.parse(dataStr))
  }
  eventBus.$emit('responseHttpError', error.response.status, error)
  return Promise.reject(error)
})

export default service
export { outSiteRequest, serviceV2 }
